const CRITERIA_CARD_PREFIX = 'criteria-view-card';

// Element types
const CONTAINER = 'container';
const SERIAL_NUMBER = 'serial-number';
const MOVE_UP_BUTTON = 'move-up-button';
const MOVE_DOWN_BUTTON = 'move-down-button';
const DRAG_HANDLE = 'drag-handle';
const CARD_TYPE = 'card-type';
const STATUS_CHIP = 'status-chip';
const INDEX_DATE_SELECTION = 'index-date-selection';
const TITLE = 'title';
const DETAILS_SECTION = 'details-section';
const DETAIL_KEY = 'detail-key';
const DETAIL_VALUE = 'detail-value';
const EDIT_BUTTON = 'edit-button';
const DELETE_BUTTON = 'delete-button';

/**
 * Generate testIds for CriteriaViewCard elements
 *
 * @param id Unique identifier for the criteria
 * @returns Object with all locator functions for the specific criteria
 */
export const useCriteriaViewCardLocators = (id: string) => {
  return {
    // Main container
    containerTestId: `${CRITERIA_CARD_PREFIX}-${CONTAINER}-${id}`,

    // Header elements
    serialNumberTestId: `${CRITERIA_CARD_PREFIX}-${SERIAL_NUMBER}-${id}`,
    moveUpButtonTestId: `${CRITERIA_CARD_PREFIX}-${MOVE_UP_BUTTON}-${id}`,
    moveDownButtonTestId: `${CRITERIA_CARD_PREFIX}-${MOVE_DOWN_BUTTON}-${id}`,
    dragHandleTestId: `${CRITERIA_CARD_PREFIX}-${DRAG_HANDLE}-${id}`,

    // Info section
    cardTypeTestId: `${CRITERIA_CARD_PREFIX}-${CARD_TYPE}-${id}`,
    statusChipTestId: (index: number) => `${CRITERIA_CARD_PREFIX}-${STATUS_CHIP}-${id}-${index}`,
    indexDateSelectionTestId: `${CRITERIA_CARD_PREFIX}-${INDEX_DATE_SELECTION}-${id}`,

    // Content
    titleTestId: `${CRITERIA_CARD_PREFIX}-${TITLE}-${id}`,
    detailsSectionTestId: `${CRITERIA_CARD_PREFIX}-${DETAILS_SECTION}-${id}`,
    detailKeyTestId: (index: number) => `${CRITERIA_CARD_PREFIX}-${DETAIL_KEY}-${id}-${index}`,
    detailValueTestId: (index: number) => `${CRITERIA_CARD_PREFIX}-${DETAIL_VALUE}-${id}-${index}`,

    // Actions
    editButtonTestId: `${CRITERIA_CARD_PREFIX}-${EDIT_BUTTON}-${id}`,
    deleteButtonTestId: `${CRITERIA_CARD_PREFIX}-${DELETE_BUTTON}-${id}`,
  };
};
